import { el } from "@dhx/ts-common/dom";

export function title(item: any, widgetName: string) {
	return el("span", {
		"class": "dhx_navbar-title" + " dhx_navbar-title--" + widgetName,
		".innerHTML": item.html
	}, !item.html ? item.value : null);
}